// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__B0rFL","bare":"IconButton_bare__PeyKf","ghost":"IconButton_ghost__Ti1g-","solid":"IconButton_solid__BL4sj"};